// apps/web/src/layouts/AppLayout/AppLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/Sidebar/Sidebar';
import MainNav from '../../components/MainNav/MainNav';
import ToastStack from '../../components/ToastStack/ToastStack';
import RewardDebugPanel from '../../components/RewardDebugPanel/RewardDebugPanel';
import AppFooter from '../../components/AppFooter/AppFooter';
import SessionGate from '../../components/SessionGate/SessionGate';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import ScrollRestoration from '../../components/ScrollRestoration/ScrollRestoration';
import VerifyEmailBanner from '../../components/VerifyEmailBanner/VerifyEmailBanner';
import styles from './AppLayout.module.scss';

const AppLayout: React.FC = () => {
	return (
		<div className={styles.wrapper}>
			{/* Resets scroll to the top on every route (pathname) change, unless
			    the URL targets a specific #section. Renders nothing. */}
			<ScrollRestoration />
			<Sidebar />
			<main className={styles.main}>
				<MainNav />
				<section className={styles.content}>
					<SessionGate>
						<VerifyEmailBanner />
						<Outlet />
					</SessionGate>
				</section>
				<AppFooter />
			</main>
			{/* Single unified notification stack — replaces the former
			    separate GemToast + BadgeToast. Reads both Redux queues
			    internally and renders one top-right stack. */}
			<ToastStack />
			<RewardDebugPanel />
			<ScrollToTop />
		</div>
	);
};

export default AppLayout;
